import {
  backendFetchCached,
  backendPatch,
  invalidateCache,
} from './BackendApi.ts';
import { EhrIntegrationSettingsData } from '@/common/types';
import { objectToFormData } from '@/common/utilities/objectToFormData.ts';

export async function loadEhrIntegrationSettings(): Promise<EhrIntegrationSettingsData> {
  return backendFetchCached<EhrIntegrationSettingsData>(
    '/ehr_integration_settings',
    {
      key: 'ehr_integration_settings_cache_v1',
      ttlMinutes: 24 * 60, // 24 hours
    },
    {
      credentials: 'include',
    }
  );
}

export async function updateEhrIntegrationSettings(
  data: Partial<{
    ehrProvider: string;
    patientLoginUrl: string;
    providerAppointmentBaseUrl: string;
  }>
): Promise<EhrIntegrationSettingsData> {
  const formData = objectToFormData(data, 'ehr_integration_setting');

  const result = await backendPatch<EhrIntegrationSettingsData>(
    '/ehr_integration_settings',
    formData,
    {
      credentials: 'include',
    }
  );

  // Invalidate the cache so the next fetch gets fresh data
  invalidateCache('ehr_integration_settings_cache_v1');

  return result;
}
